import {
    message, Progress, Space,
} from 'antd';
import React, { useState, useContext, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import LandsManagement from 'Components/LandsMgmt';
import CropsManagement from 'Components/CropsMgmt';
import NotificationsMgmt from 'Components/NotificationsMgmt';
// import PlantsMgmt from 'Components/PlantsMgmt';
import SubscriptionsMgmt from 'Components/SubscriptionsMgmt';
import SupportMgmt from 'Components/SupportMgmt';
import AssociationsMgmt from 'Components/AssociationsMgmt';
import EditProfile from 'Components/EditProfile';

import UploadableAvatar from '../Media/UploadableAvatar';
import { useUpdateProfile } from '../../apis/profiles';
import { AuthContext } from '../../shared/AuthProvider';

import './styles.scss';

function ProfileDashboard({ profileId, profileEntry, setSubTitle = () => null }) {
    const [selectedPage, setSelectedPage] = useState(<EditProfile profileId={profileId} />);
    const [selectedItem, setSelectedItem] = useState('BasicDetails');
    const updateProfile = useUpdateProfile();
    const { user } = useContext(AuthContext);
    const queryClient = useQueryClient();
    const menu = [
        {
            key: 'BasicDetails',
            label: 'معلومات المستخدم',
            onClick: () => {
                setSelectedPage(<EditProfile profileId={profileId} />);
                setSelectedItem('BasicDetails');
            },
        },
        {
            key: 'SubscriptionsMgmt',
            label: 'إدارة الإشتراك',
            onClick: () => {
                setSelectedPage(<SubscriptionsMgmt profileId={profileId} />);
                setSelectedItem('SubscriptionsMgmt');
            },
        },
        {
            key: 'LandsManagement',
            label: 'إدارة الأراضي',
            onClick: () => {
                setSelectedPage(<LandsManagement profileId={profileId} profileEntry={profileEntry} />);
                setSelectedItem('LandsManagement');
            },
        },
        {
            key: 'CropsManagement',
            label: 'إدارة المحاصيل',
            onClick: () => {
                setSelectedPage(<CropsManagement profileId={profileId} profileEntry={profileEntry} />);
                setSelectedItem('CropsManagement');
            },
        },
        // {
        //     key: 'PlantsMgmt',
        //     label: 'إدارة المزروعات',
        //     onClick: () => {
        //         setSelectedPage(<PlantsMgmt profileId={profileId} />);
        //         setSelectedItem('PlantsMgmt');
        //     },
        // },
        {
            key: 'SupportMgmt',
            label: 'إدارة الدعم الفني',
            onClick: () => {
                setSelectedPage(<SupportMgmt profileId={profileId} />);
                setSelectedItem('SupportMgmt');
            },
        },
        {
            key: 'AssociationsMgmt',
            label: 'الجمعيات والتعاونيات',
            onClick: () => {
                setSelectedPage(<AssociationsMgmt profileId={profileId} />);
                setSelectedItem('AssociationsMgmt');
            },
        },
        {
            key: 'NotificationsMgmt',
            label: 'المراسلات والتنبيهات',
            onClick: () => {
                setSelectedPage(<NotificationsMgmt profileId={profileId} />);
                setSelectedItem('NotificationsMgmt');
            },
        },
    ];

    const onUploadCompleted = async (profileData, url) => {
        const newForm = {
            image: url,
        };

        if (profileData && profileId) {
            try {
                await updateProfile.mutateAsync({
                    data: newForm,
                    profileId,
                    userUid: user?.uid,
                });

                message.success('Saved image!');
            } catch {
                message.error('Error!');
            }
        }
        // profiles
        queryClient.invalidateQueries(['profiles']);
    };

    useEffect(() => {
        setSubTitle(menu[0].label);
    }, []);

    return (
        <div className="ProfileDashboard">
            <div className="Sidebar">
                <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                    <div className="UserDetails">
                        <Space direction="vertical" size={5} style={{ display: 'flex' }}>
                            <div className="Avatar">
                                <UploadableAvatar image={profileEntry?.image} entry={profileEntry} onComplete={onUploadCompleted} />
                            </div>
                            <div className="Name">{profileEntry?.name}</div>
                            <div className="Location">{profileEntry?.address?.city?.arabic}</div>
                            <div className="Email">{profileEntry?.email}</div>
                        </Space>
                    </div>
                    <div className="Menu">
                        <ul>
                            {
                                menu.map((entry) => (
                                    <li key={entry?.key}>
                                        <button
                                            onClick={() => {
                                                entry.onClick();
                                                setSubTitle(entry.label);
                                            }}
                                            type="button"
                                            className={selectedItem === entry.key ? 'selected' : ''}
                                        >
                                            {entry.label}
                                        </button>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                    <div className="UserDetails">
                        <Space direction="vertical" size={5} style={{ display: 'flex' }}>
                            <div className="Name">مستوى المعلومات</div>
                            <Progress percent={profileEntry.infoPercentage} />
                        </Space>
                    </div>
                </Space>
            </div>
            <div className="MainContent">
                {selectedPage}
            </div>
        </div>
    );
}

export default ProfileDashboard;
